// extracted by mini-css-extract-plugin
export default {"container":"InformativeCard_container__1D+vb","overlay":"InformativeCard_overlay__yK6bw","left":"InformativeCard_left__kQ-rS"};